import React, {useState} from 'react';
import {Drawer, Input} from 'antd';
import CloseIcon from '../../../Icons/Close';
import Button from '../../../Button';
import InputPhone from '../../../InputPhone';
let formTimeout = null;

const MobileRecipientForm = ({open, onClose, onChange, recipient = {}, ...props}) => {
  const
    [localVal, setLocalVal]:any = useState(recipient),
    {cartState} = props,
    hasNameError = cartState.orderErrors?.user_name,
    handleSubmit = () => {
      onChange(localVal);
      onClose();
    },
    handleChange = (attr, type = 'input') => (event) => {
      const newAddress = {
        ...localVal,
        [attr]: type === 'boolean' ? event.target.checked : event.target.value
      }

      setLocalVal(newAddress);
      clearTimeout(formTimeout);

      formTimeout = setTimeout(() => onChange(newAddress), 500);
    },
    handleContactChanged = (attr) => (value) => {
      const newRecipient = {
        ...localVal,
        [attr]: value
      }

      setLocalVal(newRecipient);
      clearTimeout(formTimeout);

      formTimeout = setTimeout(() => onChange(newRecipient), 500);
    };
  return (
    <>
      <Drawer
        className='select-drawer ant-drawer-bottom-radius'
        getContainer='body'
        height='auto'
        placement='bottom'
        onClose={onClose}
        title='Введите данные'
        closeIcon={<CloseIcon />}
        footer={<Button onClick={handleSubmit} className='w-full lg'>Сохранить и продолжить</Button>}
        open={open}
      >
        <div className='burger-menu-drawer__body'>
          <div className='mobile-form mobile-form_address'>
            <div className='mobile-form__row'>
              <div className='mobile-form__field'>
                <div className='mobile-form__field-input'>
                  <InputPhone
                    value={localVal.phone}
                    placeholder='Телефон'
                    onChange={handleContactChanged('phone')}
                    className={`${cartState.orderErrors?.user_phone ? 'error' : ''}`}
                  />
                </div>
              </div>
            </div>
            <div className='mobile-form__row'>
              <div className='mobile-form__field'>
                <div className='mobile-form__field-input'>
                  <Input value={localVal.last_name} placeholder='Фамилия' onChange={handleChange('last_name')} className={`${hasNameError ? 'error' : ''}`} />
                </div>
              </div>
            </div>
            <div className='mobile-form__row'>
              <div className='mobile-form__field'>
                <div className='mobile-form__field-input'>
                  <Input value={localVal.first_name} placeholder='Имя*' onChange={handleChange('first_name')} className={`${hasNameError ? 'error' : ''}`} />
                </div>
              </div>
            </div>
            <div className='mobile-form__row'>
              <div className='mobile-form__field'>
                <div className='mobile-form__field-input'>
                  <Input value={localVal.patronymic} placeholder='Отчество' onChange={handleChange('patronymic')} className={`${hasNameError ? 'error' : ''}`} />
                </div>
              </div>
            </div>
            <div className='mobile-form__row'>
              <div className='mobile-form__field'>
                <div className='mobile-form__field-input'>
                  <Input
                    type='email'
                    value={localVal.email}
                    placeholder='Почта'
                    onChange={handleChange('email')}
                    className={`${cartState.orderErrors?.user_email ? 'error' : ''}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>

  );
}

export default MobileRecipientForm;
